import { render, staticRenderFns } from "./viewTableItem.vue?vue&type=template&id=44fea31a&"
import script from "./viewTableItem.vue?vue&type=script&lang=js&"
export * from "./viewTableItem.vue?vue&type=script&lang=js&"
import style0 from "./viewTableItem.vue?vue&type=style&index=0&id=44fea31a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports